module.exports = __webpack_public_path__ + "img/close.01f53397.png";